var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "button",
      attrs: { type: "submit", disabled: _vm.isLoading },
    },
    [
      !_vm.isLoading
        ? _vm._t("default")
        : _c("span", { staticClass: "spinner" }, [
            _vm._v(_vm._s(_vm.loadingLabel)),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }